import { useAuthStore } from '@/stores/authStore'
import { useDashboardStats } from '@/hooks'
import { StatsGrid, DeadlineWidget, PriorityTaskList } from '@/components/Dashboard'
import { MyWeekProgress } from '@/components/Dashboard/MyWeekProgress'
import { ProactiveCard } from '@/components/AgentActivity/ProactiveCard'
import { useProactiveCards } from '@/hooks/useProactiveCards'
import { Timer } from '@/components/Timer'

function getGreeting(): string {
  const hour = new Date().getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  return 'Good evening'
}

export function MemberDashboard() {
  const { user } = useAuthStore()
  const { stats, isLoading } = useDashboardStats()
  const { suggestions, dismiss } = useProactiveCards()

  const firstName = user?.name?.split(' ')[0] || 'there'

  return (
    <div className="space-y-6">
      {/* Proactive agent suggestions — max 3 */}
      {suggestions.length > 0 && (
        <div className="space-y-2">
          {suggestions.map((s) => (
            <ProactiveCard key={s.id} suggestion={s} onDismiss={dismiss} />
          ))}
        </div>
      )}

      {/* Welcome message */}
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          {getGreeting()}, {firstName}
        </h1>
        <p className="text-muted-foreground">
          Here's your workday.
        </p>
      </div>

      {/* Personal stats grid — reuses existing StatsGrid with personal data */}
      <StatsGrid stats={stats} isLoading={isLoading} />

      {/* Main content grid */}
      <div className="grid gap-6 lg:grid-cols-3">
        {/* Left column - Priority Tasks (hero) */}
        <div className="lg:col-span-2">
          <PriorityTaskList />
        </div>

        {/* Right column - Timer, My Week, Deadlines */}
        <div className="space-y-6">
          <Timer />
          <MyWeekProgress />
          <DeadlineWidget />
        </div>
      </div>
    </div>
  )
}
